import api from './api';

export interface BenchmarkResult {
  stream: string;
  provider: string;
  model: string;
  label: string;
  f1: number;
  precision: number;
  recall: number;
  completeness: number;
  grounded_rate: number;
  hallucination_rate: number;
  latency_ms: number;
  cost_usd: number;
  energy_joules: number;
  energy_source?: string;
  docs: number;
  error?: string | null;
}

export interface BenchmarkRun {
  id: string;
  holdout_size: number;
  schema_version_id?: string | null;
  results: BenchmarkResult[];
  winner?: string | null;
  created_by?: string;
  created_at?: string;
}

export interface BenchmarkSummary {
  latest: {
    f1: number;
    winner: string | null;
    label: string | null;
    holdout: number;
    models: number;
  } | null;
  trend: { f1: number; winner: string | null; at: string | null }[];
}

export interface BenchmarkTarget {
  stream: string;
  provider: string;
  model: string;
  label: string;
  available: boolean;
}

class BenchmarkService {
  async targets(): Promise<{ targets: BenchmarkTarget[] }> {
    return (await api.get('/benchmark/targets')).data;
  }
  async summary(): Promise<BenchmarkSummary> {
    return (await api.get('/benchmark/summary')).data;
  }
  async run(holdout: number, providers?: string[]): Promise<{ benchmark: BenchmarkRun }> {
    return (await api.post('/benchmark/run', { holdout, providers: providers ?? null })).data;
  }
  async runs(): Promise<{ runs: BenchmarkRun[] }> {
    return (await api.get('/benchmark/runs')).data;
  }
  async run_detail(id: string): Promise<{ benchmark: BenchmarkRun }> {
    return (await api.get(`/benchmark/runs/${id}`)).data;
  }
}

export const benchmarkService = new BenchmarkService();
export default benchmarkService;
